import axios from "axios";
import { setLastRequest, setUserData } from "../../store/slice/usageInfoSlice";
import { store } from "../../store/store";
import { getGroupID } from "../GroupContext";
import sqldatabaseService from "../sqldatabase/sqldatabase.service";
const baseUrl = process.env.REACT_APP_BACKEND_API;

// this file contains all calls to the authorization endpoints on the server.

// first call as part of Entra ID OAuth2 flow, server function redirects user to the login.microsoftonline.com to provide a code in the url params
const login = async () => {
  try {
    return `${baseUrl}/login`;
  } catch (err) {
    return "";
  }
};

// second call as part of Entra ID OAuth2 flow, calls endpoint to authenticate user and returns the jwt (token)
const getToken = async (params) => {
  try {
    const { data } = await axios.get(`${baseUrl}/authorize${params}`, {
      withCredentials: true,
    });
    store.dispatch(setLastRequest(Date.now()));
    return { status: 200, data: data };
  } catch (err) {
    return { status: 400, err: err };
  }
};

// logs the user out by invalidating the token
const logout = async () => {
  const user = store.getState().usageInfo.user;

  if (!user) {
    window.location.href = "/";
    return;
  }

  try {
    const response = await axios.post(
      `${baseUrl}/logout`,
      {
        id_token: user?.id_token,
      },
      {
        headers: {
          Authorization: `Bearer ${user?.id_token}`,
        },
        withCredentials: true,
      },
    );

    if (response?.status === 200) {
      const groupID = getGroupID();
      if (groupID) {
        try {
          await sqldatabaseService?.postRemoveGroupLock(groupID);
        } catch (lockErr) {
          console.warn("Failed to remove group lock:", lockErr);
        }
      }

      // Response has endsession at root level from backend
      const endsessionUrl = response.data?.endsession;

      if (endsessionUrl) {
        store.dispatch(setUserData(null));
        store.dispatch(setLastRequest(null));
        // Use window.location.replace() instead of href for external domain redirect
        setTimeout(() => {
          window.location.replace(endsessionUrl);
        }, 100);
      } else {
        store.dispatch(setUserData(null));
        store.dispatch(setLastRequest(null));
        window.location.href = "/";
      }
    } else {
      console.error("Logout returned non-200 status:", response?.status);
      window.location.href = "/";
    }
    return response;
  } catch (err) {
    store.dispatch(setUserData(null));
    store.dispatch(setLastRequest(null));
    window.location.href = "/";
    return { status: 400, err: err?.response?.data };
  }
};

const refresh = async () => {
  const user = store.getState().usageInfo.user;
  if (!user) {
    return { status: 400, err: "No user saved" };
  }

  if (!user.refresh_token) {
    console.error("No refresh_token in user object:", user);
    return { status: 400, err: "No refresh_token available" };
  }

  try {
    const response = await axios.post(
      `${baseUrl}/refresh`,
      {
        refreshToken: user?.refresh_token,
      },
      {
        headers: {
          Authorization: `Bearer ${user?.id_token}`,
        },
        withCredentials: true,
      },
    );

    if (response?.status === 200) {
      store.dispatch(setLastRequest(Date.now()));
      return { status: 200, data: response.data };
    }
    return response;
  } catch (err) {
    return { status: 400, err: err?.response?.data };
  }
};

export default { login, getToken, logout, refresh };
